import { defineComponent, ref, computed, onMounted } from 'vue';
import Sidebar from '@/components/Sidebar.vue';
import Header from '@/components/HeaderDashboard.vue';
import Swal from 'sweetalert2';
import { SearchIcon, PlusIcon, EyeIcon, CheckCircleIcon } from 'lucide-vue-next';
import { NotaCreditoService } from '@/services/NotaCreditoService';
import { hasPermission } from '@/store/userStore';
import { PERMISSIONS } from '@/constants/permissions';
export default defineComponent({
    name: 'NotasCredito',
    components: {
        Sidebar, Header,
        SearchIcon, PlusIcon, EyeIcon, CheckCircleIcon
    },
    setup() {
        const notas = ref([]);
        const loading = ref(true);
        const searchQuery = ref('');
        const canCreate = computed(() => hasPermission(PERMISSIONS.NOTAS_CREDITO.CREATE));
        const canConfirm = computed(() => hasPermission(PERMISSIONS.NOTAS_CREDITO.CONFIRMAR));
        onMounted(async () => {
            cargarNotas();
        });
        const cargarNotas = async () => {
            try {
                loading.value = true;
                const res = await NotaCreditoService.getAll();
                if (res.exito) {
                    notas.value = res.datos;
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                loading.value = false;
            }
        };
        const filteredNotas = computed(() => {
            if (!searchQuery.value)
                return notas.value;
            const lower = searchQuery.value.toLowerCase();
            return notas.value.filter(n => n.codigoNota.toLowerCase().includes(lower) ||
                n.nombreCliente.toLowerCase().includes(lower));
        });
        const getEstadoClase = (estado) => {
            const map = {
                'PendienteAlmacen': 'pill-warning',
                'Confirmada': 'pill-success',
                'Reembolsada': 'pill-blue',
            };
            return map[estado] || 'pill-default';
        };
        const mapEstado = (estado) => {
            if (estado === 'PendienteAlmacen')
                return 'Pendiente Almacén';
            return estado;
        };
        const abrirModalCreacion = () => {
            Swal.fire({
                icon: 'info',
                title: 'Módulo en desarrollo',
                text: 'La emisión interactiva de notas de crédito estará disponible próximamente.',
                confirmButtonColor: '#3b82f6'
            });
        };
        const verDetalles = (nota) => {
            let html = `<div style="text-align: left;"><p style="font-size: 14px; color: #475569; margin-bottom: 15px;"><strong>Motivo:</strong> ${nota.motivo}</p>
        <div style="border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden;">
          <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
             <thead style="background: #f8fafc; border-bottom: 1px solid #e2e8f0;">
                <tr>
                   <th style="padding: 10px 12px; text-align: left; color: #64748b;">Producto</th>
                   <th style="padding: 10px 12px; text-align: center; color: #64748b;">Cant.</th>
                   <th style="padding: 10px 12px; text-align: right; color: #64748b;">Subtotal</th>
                </tr>
             </thead>
             <tbody>`;
            nota.detalles.forEach(d => {
                html += `<tr>
            <td style="padding: 10px 12px; border-bottom: 1px solid #f1f5f9; color: #1e293b; font-weight: 600;">${d.nombreProducto}</td>
            <td style="padding: 10px 12px; text-align: center; border-bottom: 1px solid #f1f5f9; color: #475569;">x${d.cantidad}</td>
            <td style="padding: 10px 12px; text-align: right; border-bottom: 1px solid #f1f5f9; color: #10b981; font-weight: 700;">$${d.subtotalUsd.toFixed(2)}</td>
         </tr>`;
            });
            html += `</tbody></table></div></div>`;
            Swal.fire({
                title: `<div style="font-size: 1.25rem; font-weight: 800; color: #0f172a; margin-bottom: -10px;">NC ${nota.codigoNota}</div>`,
                html: html,
                width: 500,
                confirmButtonColor: '#3b82f6',
                confirmButtonText: 'Cerrar'
            });
        };
        const confirmarReingreso = async (nota) => {
            const confirm = await Swal.fire({
                title: 'Confirmar Reingreso',
                text: '¿Han ingresado físicamente los productos al almacén?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, confirmar ingreso',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#10b981',
            });
            if (confirm.isConfirmed) {
                try {
                    Swal.showLoading();
                    const res = await NotaCreditoService.confirmarReingreso(nota.notaCreditoId);
                    if (res.exito) {
                        Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Ingreso Confirmado', text: 'El inventario ha sido actualizado.', showConfirmButton: false, timer: 2000 });
                        cargarNotas();
                    }
                }
                catch (error) {
                    Swal.fire('Error', 'No se pudo confirmar el reingreso.', 'error');
                }
            }
        };
        return {
            notas, loading, searchQuery, filteredNotas,
            verDetalles, confirmarReingreso, abrirModalCreacion,
            canCreate, canConfirm, getEstadoClase, mapEstado
        };
    }
});
